import { useMemo } from 'react'

// Styles
import { AccountPillContainer } from './accountPill.styles'

interface AccountPillProps {
  account: string
  hiddeable?: boolean
  link?:string
}

export const AccountPill = ({
  account,
  hiddeable,
  link,
  ...rest
}: AccountPillProps): React.ReactElement => {
  const formattedAccount = useMemo(() => {
    const length = account.length

    return `${account.slice(0, 4)}...${account.slice(length - 4, length)}`
  }, [account])

  return (
    <AccountPillContainer onClick={() => window.open(link, '_blank')?.focus()} hiddeable={hiddeable} {...rest}>
      {formattedAccount}
    </AccountPillContainer>
  )
}
